var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ProductDetailBase',{attrs:{"route-key":"/products/oil-immersed"}})
}
var staticRenderFns = []

export { render, staticRenderFns }